import { render, staticRenderFns } from "./templateTypeList.vue?vue&type=template&id=118b06c0&"
import script from "./templateTypeList.vue?vue&type=script&lang=js&"
export * from "./templateTypeList.vue?vue&type=script&lang=js&"
import style0 from "./templateTypeList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports